import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { Subtype } from '@scenario/models/subtype.model';
import { RootState } from '@store/create-store';

export interface SubtypesState {
  subtypes: Subtype[];
  isFetching: boolean;
  error?: string;
}

const initialState: SubtypesState = {
  subtypes: [],
  isFetching: false,
};

export const subtypesSlice = createSlice({
  name: 'subtypes',
  initialState,
  reducers: {
    retrieveSubtypes: state => {
      state.isFetching = true;
    },
    retrieveSubtypesSuccess: (state, action: PayloadAction<Subtype[]>) => {
      state.subtypes = [...action.payload].sort((a, b) => a.name.localeCompare(b.name));
      state.isFetching = false;
    },
    retrieveSubtypesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type SubtypesViewModel = {
  subtypes: Subtype[];
  isFetching: boolean;
  error?: string;
};

export const selectSubtypesViewModel = createSelector(
  (state: RootState) => state,
  (state): SubtypesViewModel => ({
    subtypes: state.subtypes.subtypes,
    isFetching: state.subtypes.isFetching,
    error: state.subtypes.error,
  }),
);
export const { retrieveSubtypes, retrieveSubtypesSuccess, retrieveSubtypesFailure } =
  subtypesSlice.actions;

export default subtypesSlice.reducer;
